<template>
    <div>
        <textarea
            :name="inputName"
            :maxlength="inputMaxLength"
            :placeholder="inputPlaceholder"
            :rows="inputRows"
            v-model="enteredText"
            @input="emitInput"
            :class="[
                'rounded-sm border border-gray-light px-[14px] py-[11px] w-full bg-white font-sans text-[16px]',
                'focus:outline-none focus:ring-1 focus:ring-black focus:border-black',
                {
                    'h-24': inputRows == null,
                }
            ]"
        ></textarea>

        <div
            v-if="inputMessage"
            v-html="inputMessage"
            class="mt-2 text-[12px] input-html"
        >
        </div>

        <p
            v-if="showErrorMessage"
            class="mt-2 text-[12px] text-red-error"
        >
            {{ errorMessage }}
        </p>
    </div>
</template>

<script>
    export default {
        props: {
            inputName: {
                type: String,
                required: true,
            },
            inputPlaceholder: {
                type: String,
                default: '',
            },
            inputMessage: {
                type: String,
                default: '',
            },
            inputValue: {
                type: String,
                default: '',
            },
            inputRows: {
                type: Number,
                default: null,
            },
            inputMaxLength: {
                type: Number,
                default: null,
            },
            errorMessage: {
                type: String,
                default: '',
            },
            showErrorMessage: {
                type: Boolean,
                default: false,
            },
        },

        emits: ['input'],

        data() {
            return {
                enteredText: this.inputValue,
            };
        },

        watch: {
            inputValue() {
                this.enteredText = this.inputValue;
            },
        },

        methods: {
            emitInput() {
                this.$emit('input', this.enteredText);
            },
        },
    };
</script>

<style>
    #cz3 .input-html a {
        @apply underline;
    }
    textarea::placeholder {
        color: #999999 !important;
    }
</style>
